import { z } from 'zod';

export const OPPORTUNITY_STAGES = [
  'prospecting',
  'qualification',
  'proposal',
  'negotiation',
  'closed_won',
  'closed_lost',
] as const;
export const opportunityStageEnum = z.enum(OPPORTUNITY_STAGES);
export type OpportunityStage = z.infer<typeof opportunityStageEnum>;

const productLineSchema = z.object({
  name: z.string().trim().min(1, 'Name is required').max(160),
  quantity: z.coerce.number().min(0).default(1),
  unitPrice: z.coerce.number().min(0).default(0),
});

export const createOpportunitySchema = z.object({
  title: z.string().trim().min(2, 'Title must be at least 2 characters').max(200),
  customerId: z.string().optional(),
  leadId: z.string().optional(),

  stage: opportunityStageEnum.default('prospecting'),
  /** Auto-filled from `stage` server-side when omitted — see `opportunity.service.ts`. */
  probability: z.coerce.number().min(0).max(100).optional(),
  value: z.coerce.number().min(0).default(0),
  currency: z.string().trim().max(10).default('INR'),

  expectedCloseDate: z.coerce.date().optional(),

  assignedTo: z.string().optional(),

  products: z.array(productLineSchema).default([]),
  notes: z.string().trim().max(2000).optional().or(z.literal('')),
});

export type CreateOpportunityInput = z.infer<typeof createOpportunitySchema>;

export const updateOpportunitySchema = createOpportunitySchema.partial();
export type UpdateOpportunityInput = z.infer<typeof updateOpportunitySchema>;

export const closeOpportunitySchema = z.object({
  outcome: z.enum(['won', 'lost']),
  lostReason: z.string().trim().max(500).optional().or(z.literal('')),
});

export type CloseOpportunityInput = z.infer<typeof closeOpportunitySchema>;

export const opportunityListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
  stage: opportunityStageEnum.optional(),
  assignedTo: z.string().optional(),
  search: z.string().trim().max(200).optional(),
});

export type OpportunityListQuery = z.infer<typeof opportunityListQuerySchema>;
